// Profile
import profile from '../assets/1.png';

// About
import nitj from '../assets/nitj.png';
import backend from '../assets/backend2.png';
import frontend from '../assets/frontend2.png';

// Ventures
import open5gs from '../assets/open5gs.png';
import magma from '../assets/magma.png';
import redpanda from '../assets/redpanda.png';
import clickhouse from '../assets/clickhouse.png';
import cgrates from '../assets/cgrates.png';
import opensips from '../assets/opensips.png';

// Projects
import youtube from '../assets/projects/youtube.png';
import urlShortner from '../assets/projects/url-shortner.png';
import soormeLogo from '../assets/projects/soorme-logo.png';
import socialmedia from '../assets/projects/social-media.png';
import googleForms from '../assets/projects/google-forms.png';
import portfolioGen from '../assets/projects/portfolio.png';

import taura from '../assets/projects/taura.png';


// Education
import nitjLogo from '../assets/education/nitj.png';
import asmLogo from '../assets/education/asm.png';
import mspLogo from '../assets/education/msp.png';



const images = {
    profile, backend, frontend, nitj, open5gs, magma, redpanda, clickhouse, cgrates, opensips, youtube, taura, soormeLogo, urlShortner, socialmedia, googleForms, portfolioGen, nitjLogo, asmLogo, mspLogo
}

export default images;
